import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobCostKeys } from '@/lib/queryKeys';
import type { JobCostSummary } from '@/types/costing';

/** NOT-339 §12 — budget-vs-actual cost summary for a job (contract roll-up). */
export function useJobCostSummary(jobId: string, enabled = true) {
  return useApiQuery<JobCostSummary>({
    queryKey: jobCostKeys.summary(jobId),
    queryFn: () => apiGet<JobCostSummary>(operationsClient, jobEndpoints.costSummary(jobId)),
    enabled: Boolean(jobId) && enabled,
    showErrorToast: false,
  });
}
